<style lang="scss" scoped>
@screen mobile {
  .anamnesis {
    @apply px-0;
    &__header {
      @apply px-2;
    }
    &__item {
      @apply px-4;
    }
    &__name {
      @apply font-bold;
    }
    &__office-picker {
      @apply flex-wrap;
      &--none {
        @apply w-full m-2;
      }
      &--wrapper {
        >div {
          @apply text-base m-1;
        }
      }
    }
    &__actions {
      @apply justify-between w-full flex-none pt-1 pb-4;
      &-icon {
        &--btn {
          @apply bg-blueAlt  h-8 w-8 p-1 flex rounded-full items-center justify-center;
          >* {
            @apply w-5;
          }
        }
      }
    }
  }
}
</style>

<template>
  <article class="anamnesis">
    <header class="anamnesis__header">
      <h3 class="anamnesis__title">Modelos de Anamneses</h3>

      <nav class="anamnesis__menu">
        <div class="anamnesis__menu-item">
          <div class="form-group" v-show="anamnesisList.length > 0 && loaded && false">
            <label class="form-label">
              <select class="form-select">
                <option disabled selected hidden>Ações</option>
              </select>
            </label>
          </div>
        </div>

        <div class="anamnesis__menu-item TOUR_MODELS_DoctorModelsAnamnesisList">
          <router-link
            :to="{ name: 'DoctorModelsAnamnesisDetails', params: { id: 'new' } }"
            class="btn btn-sm btn-primary anamnesis__new"
            :class="fn_IS_MOBILE() ? 'btn-lg' : ''"
          >
            Adicionar Anamnese
          </router-link>
        </div>
      </nav>
    </header>

    <section class="anamnesis__list" v-click-outside="hideAllOfficesList">
      <header
        class="anamnesis__item anamnesis__item-header"
        v-if="anamnesisList.length > 0"
      >
        <div class="anamnesis__check">
          <!-- <label class="form-checkbox">
            <input type="checkbox" v-model="checkAll">
            <i class="form-icon" />
          </label> -->
        </div>

        <div class="anamnesis__name anamnesis__name--title">
          <span>Anamneses</span>
        </div>
      </header>

      <div
        class="anamnesis__item"
        :key="`anamnesis_${i}`"
        v-for="(anamnesis, i) in anamnesisList"
      >
        <div class="anamnesis__check">
          <!-- <label class="form-checkbox">
            <input type="checkbox" v-model="anamnesis.isChecked">
            <i class="form-icon" />
          </label> -->
        </div>

        <div class="anamnesis__name" @click="hideAllOfficesList()">
          <a @click.prevent="previewAnamnesis(i)">
            {{ anamnesis.name }}
          </a>
        </div>

        <div
          class="anamnesis__office-picker"
          @click.self="showOfficesList(anamnesis)"
          :class="anamnesis.showList ? 'anamnesis__office-picker--active' : ''"
        >
          <span
            @click.self="showOfficesList(anamnesis)"
            v-if="(anamnesis['doctor_offices'].length !== doctorOffices.length && fn_IS_MOBILE()) || (anamnesis['doctor_offices'].length === 0 && !fn_IS_MOBILE())"
            class="anamnesis__office-picker--none"
          >
            Clique aqui para vincular a anamnese a algum consultório.
          </span>

          <div
            class="anamnesis__office-picker--wrapper"
            @click.self="showOfficesList(anamnesis)"
            v-if="anamnesis['doctor_offices'].length > 0"
          >
            <div
              :key="`anamnesis_${i}_selected_${k}`"
              v-for="(office, k) in anamnesis['doctor_offices']"
              class="anamnesis__office"
            >
              {{ office.name }}
              <div
                class="anamnesis__office-remove"
                @click.self="removeAnamnesisFromOffice(anamnesis.id, office.id)"
              >
              </div>
            </div>
          </div>

          <transition name="slide-down" v-if="anamnesis.showList">
            <div class="anamnesis__office-list-wrapper">
              <ul class="anamnesis__office-list">
                <li
                  :key="`doctorOffice_${i}${j}`"
                  v-for="(office, j) in filterOffices(anamnesis.id)"
                  class="anamnesis__office-list-item"
                >
                    <span @click.self="addAnamnesisToOffice(office.id, anamnesis.id)">
                      {{ office.name }}
                    </span>
                </li>
              </ul>
            </div>
          </transition>
        </div>

        <div v-if="fn_IS_MOBILE()" class="anamnesis__actions">
          <dr-switch
            v-model="anamnesis['is_active']"
            :id="anamnesis.name"
            class="anamnesis__actions-icon transform scale-150"
            @change="toggleActivateAnamnesis(anamnesis.id, anamnesis['is_active'])"
          />

          <button
            class="anamnesis__actions-icon anamnesis__actions-icon--btn"
            @click="$router.push({ name: 'DoctorModelsAnamnesisDetails', params: { id: anamnesis.id } })"
          >
            <dr-icon
              :color="'#ffffff'"
              class="anamnesis__actions-icon--edit"
              name="edit"
            />
          </button>

          <button
            class="anamnesis__actions-icon anamnesis__actions-icon--btn"
            @click="removeAnamnesis(anamnesis.id)"
          >
            <dr-icon
              :color="'#ffffff'"
              class="anamnesis__actions-icon--delete"
              name="trash"
            />
          </button>
        </div>
        <div v-else class="anamnesis__actions">
          <div
            @mouseenter="event => showTooltip(event, anamnesis['is_active'])"
            @mouseleave="event => hideTooltip(event)"
          >
            <dr-switch
              v-model="anamnesis['is_active']"
              :id="anamnesis.name"
              class="anamnesis__actions-icon"
              @change="toggleActivateAnamnesis(anamnesis.id, anamnesis['is_active'])"
            />
          </div>

          <button
            class="anamnesis__actions-icon anamnesis__actions-icon--btn"
            @click="$router.push({ name: 'DoctorModelsAnamnesisDetails', params: { id: anamnesis.id } })"
          >
            <dr-icon
              :color="'#8E8E92'"
              class="anamnesis__actions-icon--edit"
              name="edit"
            />
          </button>

          <button
            class="anamnesis__actions-icon anamnesis__actions-icon--btn"
            @click="removeAnamnesis(anamnesis.id)"
          >
            <dr-icon
              :color="'#8E8E92'"
              class="anamnesis__actions-icon--delete"
              name="trash"
            />
          </button>
        </div>

      </div>

      <p
        class="anamnesis__no-anamnesis no-data"
        v-if="anamnesisList.length === 0 && loaded"
      >
        Você ainda não tem nenhum modelo de anamnese cadastrado.
      </p>

      <dr-loader
        v-if="!loaded"
        :key="'dr-loader'"
        size="lg"
        class="loader flex-center"
      />
    </section>

    <anamnesisPreview
      :anamnesisId="activeAnamnesis.id"
      v-if="isModalActive"
      @close="closeModal()"
    />
  </article>
</template>

<script>
import anamnesisPreview from '@/components/modals/anamnesisPreview'
import DrSwitch from '@/components/form/switch'
import { mapGetters } from 'vuex'

export default {
  name: 'DrAnamnesisList',

  components: {
    DrSwitch,
    anamnesisPreview
  },

  data () {
    return {
      isModalActive: false,
      activeAnamnesis: null,
      loaded: false,
      checkAll: false,
      anamnesisList: []
    }
  },

  computed: {
    ...mapGetters({
      doctorOffices: 'getOffices',
      office: 'getCurrentOffice'
    })
  },

  watch: {
    checkAll (next, prev) {
      if (next) {
        this.anamnesisList = this.updateIsChecked(this.anamnesisList)
      } else {
        this.anamnesisList = this.updateIsChecked(this.anamnesisList, false)
      }
    },

    anamnesisList: {
      immediate: false,
      deep: true,
      handler (next, prev) {
        next.forEach((a) => {
          if (a['doctor_offices'].length === this.doctorOffices.length) {
            a.showList = false
          }
        })
      }
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      this.fn_SHOW_PROGRESS()

      Promise.all([this.setAnamnesis(), this.setDoctorOffices()])
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.loaded = true
        })
    },

    closeModal () {
      this.isModalActive = false
    },

    updateIsChecked (obj, check = true) {
      return obj.map((entry) => {
        entry.isChecked = check
        return entry
      })
    },

    previewAnamnesis (index) {
      this.activeAnamnesis = this.anamnesisList[index]
      this.isModalActive = true
    },

    async getAnamnesis () {
      const { data } = await this.$http.get('/doctor/custom_anamnesis?itensPerPage=100', this.$store.getters.getAuthHeader)
      return data
    },

    async setAnamnesis () {
      await this.getAnamnesis()
        .then((res) => {
          this.anamnesisList = res.data.map((obj) => {
            return {
              ...obj,
              isChecked: false,
              showList: false
            }
          })
        })
        .catch(err => console.log('err\n', err))
    },

    async setDoctorOffices () {
      const anamnesisLists = []

      this.doctorOffices.forEach((office) => {
        anamnesisLists.push(
          this.getOfficeAnamnesis(office.id)
            .then(res => (office['anamnesisList'] = res))
        )
      })

      return Promise.all(anamnesisLists).finally(() => (Promise.resolve()))
    },

    async getOfficeAnamnesis (officeId) {
      const url = `/doctor/doctor_office/${officeId}/custom_anamnesis?itensPerPage=100`
      const { data } = await this.$http.get(url, this.$store.getters.getAuthHeader)
      return data.data
    },

    showOfficesList (anamnesis) {
      this.hideAllOfficesList(anamnesis)
      if (anamnesis['doctor_offices'].length !== this.doctorOffices.length) {
        anamnesis.showList = !anamnesis.showList
      }
    },

    hideAllOfficesList (but = false) {
      if (!but) {
        this.anamnesisList.forEach(a => (a.showList = false))
      } else {
        this.anamnesisList.forEach((a) => {
          (a.id !== but.id) && (a.showList = false)
        })
      }
    },

    filterOffices (anamnesisId) {
      const index = this.anamnesisList.findIndex(a => anamnesisId === a.id)
      if (index > -1) {
        const doctorOffices = this.anamnesisList[index].doctor_offices
        const filter = []
        doctorOffices.forEach(o => (filter.push(o.id)))
        return this.doctorOffices.filter(o => !filter.includes(o.id))
      }
    },

    addAnamnesisToOffice (officeId, anamnesisId) {
      const url = `/doctor/custom_anamnesis/${anamnesisId}/doctor_office/${officeId}`

      this.fn_SHOW_PROGRESS()
      this.$http({
        url,
        method: 'post',
        headers: this.$store.getters.getAuthHeader.headers,
        data: {}
      })
        .then((res) => {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Anamnese vinculada com sucesso.',
            size: 'md',
            active: true
          })
        })
        .catch((err) => {
          console.warn('error:\n', err)

          this.$store.dispatch('setModalAlert', {
            title: 'Erro',
            body: err,
            size: 'md',
            active: true
          })
        })
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.hideAllOfficesList()
          this.setAnamnesis()
        })
    },

    removeAnamnesisFromOffice (anamnesisId, officeId) {
      this.$store.dispatch('setModalConfirm', {
        title: 'Confirmação',
        body: `Tem certeza que deseja remover o campo da anamnese?`,
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        beforeClose: (v) => {
          if (v) {
            const url = `/doctor/custom_anamnesis/${anamnesisId}/doctor_office/${officeId}`

            this.fn_SHOW_PROGRESS()
            this.$http({
              url,
              method: 'delete',
              headers: this.$store.getters.getAuthHeader.headers,
              data: {}
            })
              .then((res) => {
                this.$store.dispatch('setModalAlert', {
                  title: 'Sucesso',
                  body: 'Anamnese desvinculada com sucesso.',
                  size: 'md',
                  active: true
                })
              })
              .catch((err) => {
                console.warn('error:\n', err)

                this.$store.dispatch('setModalAlert', {
                  title: 'Erro',
                  body: err,
                  size: 'md',
                  active: true
                })
              })
              .finally(() => {
                this.fn_HIDE_PROGRESS()
                this.hideAllOfficesList()
                this.setAnamnesis()
              })
          }
          this.$store.dispatch('setModalConfirm')
        },
        size: 'md',
        active: true
      })
    },

    toggleActivateAnamnesis (anamnesisId, status) {
      const url = `/doctor/custom_anamnesis/${anamnesisId}/is_active`
      const data = {
        'is_active_update': {
          isActive: status ? 1 : 0
        }
      }

      this.fn_SHOW_PROGRESS()
      this.$http
        .put(url, data, this.$store.getters.getAuthHeader)
        .then((res) => {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: `Anamnese ${status ? 'ativada' : 'desativada'} com sucesso.`,
            size: 'md',
            active: true
          })
        })
        .catch(err => this.fn_HANDLE_ERROR(err))
        .finally(this.fn_HIDE_PROGRESS)
    },

    removeAnamnesis (anamnesisId) {
      const removeAnamnesis = (id) => {
        const url = `/doctor/custom_anamnesis/${id}`

        this.fn_SHOW_PROGRESS()
        this.$http
          .delete(url, this.$store.getters.getAuthHeader)
          .then((res) => {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: 'Anamnese removida com sucesso.',
              size: 'md',
              active: true
            })

            this.init()
          })
          .catch(err => this.fn_HANDLE_ERROR(err))
          .finally(this.fn_HIDE_PROGRESS())
      }

      this.$store.dispatch('setModalConfirm', {
        title: 'Confirmação',
        body: 'Tem certeza que deseja apagar essa anamnese? Esta ação não poderá ser desfeita.',
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        beforeClose: (v) => {
          if (v) {
            removeAnamnesis(anamnesisId)
          }

          this.$store.dispatch('setModalConfirm')
        },
        size: 'md',
        active: true
      })
    },

    showTooltip (event, status) {
      const addTooltip = (event) => {
        const position = event.getBoundingClientRect()
        const tooltip = document.createElement('div')

        tooltip.classList.add('agenda-online-controls__tooltip', 'confirmation-tooltip')
        tooltip.innerText = `Anamnese ${status ? 'ativa' : 'inativa'}`
        tooltip.style.display = 'none'
        tooltip.style.position = 'absolute'
        tooltip.style.bottom = 'calc(100% + 15px)'
        tooltip.style.left = `${(position.width / 2) - 17}px`
        tooltip.style.zIndex = '100'
        tooltip.style.transition = 'all ease 0.5s'

        event.style.position = 'relative'
        event.appendChild(tooltip)

        setTimeout(() => (tooltip.style.display = 'block'), 100)
      }

      addTooltip(event.target)
    },

    hideTooltip (event) {
      const removeTooltip = () => {
        const tooltip = document.querySelectorAll('.confirmation-tooltip')
        if (tooltip.length > 0) {
          tooltip.forEach(t => t.parentNode.removeChild(t))
        }
      }

      removeTooltip()
    }
  }
}
</script>
